// extracted by mini-css-extract-plugin
export var bg = "hero-module--bg--pHXWh";
export var container = "hero-module--container--pk9ny";
export var content = "hero-module--content--JCmVm";
export var image = "hero-module--image--37Lbc";
export var subHeading = "hero-module--sub-heading--js77V";
export var wrapperImage = "hero-module--wrapper-image--ZmEyU";
export var wrapperText = "hero-module--wrapper-text--it2Xt";